export const billExternalsReducer = (state = {loading: false, resultbillExternal: null, billExternals: null, billExternal: null } , action) => {
    switch (action.type) {
        case 'BILLEXTERNAL_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                billExternals: action.payload.billExternals
            }
        case 'BILLEXTERNAL_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                billExternal: action.payload.billExternal
            }
        case 'BILLEXTERNAL_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                billExternals: [...state.billExternals, action.payload.billExternal],
                resultbillExternal: action.payload.message
            }
        case 'BILLEXTERNAL_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                billExternals: state.billExternals.map(billExternal => billExternal._id === action.payload.billExternal._id ? action.payload.billExternal : billExternal),
                resultbillExternal: action.payload.message
            }
        case 'BILLEXTERNAL_REMOVE_RESULT':
            return {
                ...state,
                loading:false,
                resultbillExternal: action.payload.message,
                billExternals: state.billExternals.filter(billExternals => billExternals._id !== action.payload.billExternal)
            }
        case 'BILLEXTERNAL_RESET_RESULT':
            return {...state,
                resultbillExternal: null
            }
        case 'BILLEXTERNAL_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'BILLEXTERNAL_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'BILLEXTERNAL_DOCUMENT_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                billExternals: state.billExternals.map(billExternal => billExternal._id === action.payload.billExternal._id ? action.payload.billExternal : billExternal),
                resultbillExternal: action.payload.message
            }
        case 'BILLEXTERNAL_DOCUMENT_DELETE_SUCCESS':
            return {
                ...state,
                loading:false,
                billExternals: state.billExternals.map(billExternal => billExternal._id === action.payload.billExternal._id ? action.payload.billExternal : billExternal),
                resultbillExternal: action.payload.message
            }
        default:
            return state
    }
}

